import MONITORING_FRONTEND_ERROR_MUTATION from '@/shared/api/mutations/monitoringFrontendError';
import type {
  MonitoringFrontendErrorMutation,
  MonitoringFrontendErrorMutationVariables,
} from '@/shared/api/generated/graphql';
import createClient from '../../client/apolloClient';

export type MonitoringFrontendErrorResult = {
  isSuccess: boolean;
  message: string;
};

// TODO(ts): typed as the MonitoringFrontendErrorInput GraphQL input once its server-side shape is documented
/**
 * Reports a frontend error into the backend monitoring pipeline. Runs the monitoringFrontendError mutation and throws the server message when it does not report success.
 *
 * @param input - Mutation input describing the error to record.
 * @returns A promise resolving once the error report has been accepted.
 */
const handleMonitoringFrontendError = async (input: any) => {
  const client = await createClient();
  const result = await client.mutate<
    MonitoringFrontendErrorMutation,
    MonitoringFrontendErrorMutationVariables
  >({
    mutation: MONITORING_FRONTEND_ERROR_MUTATION,
    variables: {
      input,
    },
  });
  if (!result?.data.monitoringFrontendError?.isSuccess) {
    throw new Error(result?.data.monitoringFrontendError?.message);
  }
};

export default handleMonitoringFrontendError;
